import React, { useEffect, useState } from "react";
import AdminLayout from "../../../UI/Layout/AdminLayout";
import Title from "../../../UI/Text/Title";
import styles from "./Usercdp.module.css";
import { userloginDetails } from "../../../Utils/AdminAuth";
import Axios from "../../../../axios/Axios";
import { NODE_HOST_URL_v1 } from "../../api/Api";

const formatDate = (dateStr) => {
  if (!dateStr) return "NA";
  const date = new Date(dateStr);
  return date.toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "UTC",
  }) + " UTC";
};

/* ── Copy helper ──────────────────────────────────── */
const CopyIcon = ({ text }) => (
  <button
    className={styles.copyBtn}
    title="Copy"
    onClick={() => navigator.clipboard.writeText(text)}
  >
    ⎘
  </button>
);

/* ── Page ─────────────────────────────────────────── */
const Usercdp = () => {
  const lStorage = userloginDetails();
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  const adminType = lStorage.user.isAdmin;
  // const subAdminPermission = lStorage?.permission?.per_value
  const [expandedMap, setExpandedMap] = useState({});
  const [cdpData, setCdpData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState({
    totalRecords: 0,
    totalPages: 0
  })
  const ITEMS_PER_PAGE = 5;

  const toggleExpanded = (index) => {
    setExpandedMap((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const totalPages = Math.ceil(cdpData.length / ITEMS_PER_PAGE);
  const paginatedData = cdpData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  useEffect(() => {
    UsercdpDetails();
  }, [currentPage])

  const UsercdpDetails = async () => {
    let paramData = {
      user_id: userId,
      method: "fetchUserCdpData",
      type: adminType,
      token: userToken,
      filter: "userSignup",
      page: currentPage
    }
    let { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/AdminUserCdp`, paramData)
    if (data.success) {
      // console.log(data);
      setCdpData(data.data)
      setTotalData({
        totalRecords: data.totalRecords,
        totalPages: data.totalPages
      })
    }
  }

  // console.log(currentPage);
  



  return (
    <AdminLayout>
      <Title isButton={false}>User CDP</Title>

      <div className={styles.cardGrid}>
      {cdpData.map((items, index) => {
        const expanded = !!expandedMap[index];
        return (
          <div className={styles.page} key={index}>
            <div className={styles.card}>

              {/* ── Event top strip ── */}
              <div className={styles.eventTop}>
                <div className={styles.eventMeta}>
                  <div className={styles.metaGroup}>
                    <span className={styles.metaLabel}>Event Source</span>
                    <span className={styles.badge}>{items.event_source}</span>
                  </div>
                  <div className={styles.metaGroup}>
                    <span className={styles.metaLabel}>Event Name</span>
                    <p className={styles.metaValue}>{items.event_name}</p>
                  </div>
                </div>

                <div className={styles.fieldGrid}>
                  <div className={styles.field}>
                    <label>Name</label>
                    <p>{items.name}</p>
                  </div>
                  <div className={styles.field}>
                    <label>User ID</label>
                    <p>
                      {items.user_id}
                      <CopyIcon text={items.user_id} />
                    </p>
                  </div>
                  <div className={styles.field}>
                    <label>Email</label>
                    <p className={styles.emailLink}>{items.email}</p>
                  </div>
                  <div className={styles.field}>
                    <label>Mobile</label>
                    <p>{items.mobile}</p>
                  </div>
                </div>

                <div className={styles.dateRow}>
                  <span>🕐</span>
                  {formatDate(items.created)}
                </div>
              </div>

              {/* ── Toggle button ── */}
              <div className={styles.toggleRow}>
                <button
                  className={styles.toggleBtn}
                  onClick={() => toggleExpanded(index)}
                >
                  {expanded ? "VIEW LESS" : "VIEW MORE"}
                  <span className={styles.chevron}>{expanded ? "▲" : "▼"}</span>
                </button>
              </div>

              {/* ── Expandable details ── */}
              {expanded && (
                <div className={styles.details}>

                  {/* User Profile Details */}
                  <div className={styles.section}>
                    <p className={styles.sectionTitle}>User Profile Details</p>
                    <div className={styles.profileGrid}>
                      {items.event_data.map((dataObj) =>
                        Object.entries(dataObj).map(([key, value]) => (
                          <div className={styles.pField} key={key}>
                            <label>{key.replace(/_/g, " ")}</label>
                            <p>{value !== null && value !== undefined ? String(value) : "NA"}</p>
                          </div>
                        ))
                      )}
                    </div>
                  </div>

                  {/* Enabled Menu Features */}
                  {/* <div className={styles.section}>
                    <p className={styles.sectionTitle}>Enabled Menu Features</p>
                    <div className={styles.tags}>
                      {FEATURES.map((f) => (
                        <span key={f.label} className={`${styles.tag} ${f.cls}`}>
                          {f.label}
                        </span>
                      ))}
                    </div>
                  </div> */}

                  {/* Costs */}
                  {/* <div className={styles.section}>
                    <p className={styles.sectionTitle}>Costs</p>
                    <div className={styles.costsGrid}>
                      {COSTS.map((c) => (
                        <div className={styles.costField} key={c.label}>
                          <label>{c.label}</label>
                          <p>{c.value}</p>
                        </div>
                      ))}
                    </div>
                  </div> */}

                  {/* IP & Security */}
                  {/* <div className={styles.section}>
                    <p className={styles.sectionTitle}>IP &amp; Security</p>
                    <div className={styles.profileGrid}>
                      {IP_SECURITY.map((f) => (
                        <div className={styles.pField} key={f.label}>
                          <label>{f.label}</label>
                          <p>{f.value}</p>
                        </div>
                      ))}
                    </div>
                  </div> */}

                </div>
              )}

            </div>
          </div>
        )
      })}
      </div>

      {/* ── Pagination ── */}
      {totalPages > 1 && (
        <div className={styles.pagination}>
          <button
            className={styles.pageBtn}
            disabled={currentPage === 1}
            onClick={() => { setCurrentPage((p) => p - 1); setExpandedMap({}); }}
          >
            &#8592; Previous
          </button>

          <span className={styles.pageInfo}>
            Page {currentPage} of {totalData.totalPages}
            <span className={styles.pageInfoSub}>
              {totalData.totalRecords} total records
            </span>
          </span>

          <button
            className={styles.pageBtn}
            disabled={currentPage === totalData.totalPages}
            onClick={() => { setCurrentPage((p) => p + 1); setExpandedMap({}); }}
          >
            Next &#8594;
          </button>
        </div>
      )}
    </AdminLayout>
  );
};

export default Usercdp;
